import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) =>
  createStyles({
    phoneIcon: {
      position: "relative",
      right: -76,
      bottom: 34,
      [theme.breakpoints.down('md')]: {
        display: "none",
      },
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },
    managerIcon: {
      width: '100%',
      height: '100%',
      borderRadius: '100%',
      display: 'block'
    },
  });
